import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useRouteMatch } from 'react-router';
import { Input, Segment, Button, Dropdown } from 'semantic-ui-react';
import { AdminState } from '../../types/admin-state';
import { AppState } from '../../types/app-state';
import {
	InitialiseManageOrganisation,
	UpdateMemberState,
} from '../../actions/admin.actions';
import './OrganisationMembersPage.less';

export const OrganisationMembersPage: React.FC = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const match = useRouteMatch<{ orgId: string }>();
	const { organisations } = useSelector<AppState, Partial<AdminState>>(
		(state) => state.admin
	);
	const [filter, setFilter] = useState('');
	const orgOptions = organisations?.data.map((org) => ({
		key: 'org_' + org.id,
		value: org.id,
		text: org.name,
	}));
	const selectedOrg = organisations?.data.find(
		(org) => org.id === match.params.orgId
	);

	const handleFilterChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
		setFilter((e.target as HTMLInputElement).value);
	};

	const handleOrgSelect = (event: any, data: any) => {
		history.push(`/admin/org/${data.value}/members`);
	};

	useEffect(() => {
		dispatch(InitialiseManageOrganisation());
	}, [dispatch]);

	if (match.params.orgId === 'unselected' || !selectedOrg) {
		if (organisations && organisations.data.length > 0) {
			const firstOrg = organisations.data[0].id;
			return <Redirect to={`/admin/org/${firstOrg}/members`} />;
		}
	}

	const filteredMembers = !selectedOrg
		? []
		: (selectedOrg.members || []).filter((member) => {
				return (
					filter === '' ||
					member.id.includes(filter) ||
					(member.email || '').includes(filter) ||
					(member.first_name || '').includes(filter) ||
					(member.last_name || '').includes(filter)
				);
		  });

	return (
		<div className='organisationmembers-page'>
			<h1>Manage Organisation Members</h1>
			<Dropdown
				search
				selection
				placeholder='Select Organisation'
				value={match.params.orgId}
				onChange={handleOrgSelect}
				options={orgOptions}
			/>
			<Input
				placeholder='Filter Members'
				autoFocus
				value={filter}
				onChange={handleFilterChange}
			/>
			<Segment loading={organisations?.isRequesting}>
				{selectedOrg && selectedOrg.members && (
					<ul>
						{filteredMembers.length > 0 && (
							<li>
								<span>
									<b>Email</b>
								</span>
								<span>
									<b>Name</b>
								</span>
								<div />
							</li>
						)}
						{filteredMembers.map((member) => (
							<li
								key={member.id}
								style={{ opacity: member.is_active ? 1 : 0.5 }}
							>
								<span>{member.email}</span>
								<span>
									{member.first_name} {member.last_name}
								</span>
								<div>
									{member.is_active ? (
										<Button
											onClick={() =>
												dispatch(
													UpdateMemberState(selectedOrg.id, member.id, false)
												)
											}
										>
											Set to inactive
										</Button>
									) : (
										<Button
											onClick={() =>
												dispatch(
													UpdateMemberState(selectedOrg.id, member.id, true)
												)
											}
										>
											Set to active
										</Button>
									)}
								</div>
							</li>
						))}
						{filteredMembers.length === 0 && <li>No item matched.</li>}
					</ul>
				)}
				{selectedOrg && !selectedOrg.members && (
					<p>This organisation doesn't have members yet</p>
				)}
				{organisations?.data.length === 0 && (
					<p>There are no organisations yet</p>
				)}
			</Segment>
		</div>
	);
};

export default OrganisationMembersPage;
